import { useState } from "react";
import Sidebar from "../components/Sidebar";

export default function DashboardLayout({ children, onLogout }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <div className="flex h-screen">

      <Sidebar
        isOpen={sidebarOpen}
        toggleSidebar={toggleSidebar}
        onLogout={onLogout}
      />

      <div className="flex-1 flex flex-col overflow-hidden">
        <header className="flex items-center justify-between px-6 py-4 bg-white border-b shadow-sm">
          <h1 className="text-xl font-bold">ERP Dashboard</h1>
          <button onClick={toggleSidebar}  className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition">
            {sidebarOpen ? "×" : "☰"}
          </button>
        </header>

        <main className="flex-1 overflow-y-auto bg-gray-100 p-6">{children}</main>
      </div>
    </div>
  );
}